import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import { IndicadoresFator } from "./IndicadoresFator";
import { IndicadorDemandasAtingidasUltrapassagem } from "./IndicadorDemandasAtingidasUltrapassagem";
import { TooltipAgendamento } from "./TooltipAgendamento";
import { TooltipPeriodoTeste } from "./TooltipPeriodoTeste";
import Button from "../../common/button/button";
import AlertIcon from "../../common/alertIcon/alertIcon";
import { TabelaDemandaContratada } from "./TabelaDemandaContratada";
import ampulhetaCirculo from "../../assets/images/ampulheta_circulo.png";
import DateFormat from "../../common/dateFormat/DateFormat";
import { calcularFatorPotencia } from "../../core/calcularFatorPotencia";
import { IndicadorLeiturasFaltando } from "./IndicadorLeiturasFaltando";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import { RowFlex } from "../../common/layout/RowFlex";
import Grid from "../../common/layout/grid";
import { getListaGraficoDia, getMonitoramentoConsumo, setModoTela, setStatusVisualizado } from "../monitoramentoConsumoActions";
import { setPeriodoTesteVisualizado } from "../../demandaContrato/demandaContratoActions";
import { buscarPdfUnifilarRedeInterna } from "../../rede/redeActions";
import { setArquivoPDF } from "../../displayPDF/displayPDFActions";

function MonitoramentoConsumoCardMobileComponent(props) {
    // Estado local para manter kvar_ind_simulado
    const [kvarIndSimulado, setKvarIndSimulado] = useState(props.item.consumoLeitura.kvar_ind_simulado || 0);
    // sem id significa que não tem contrato de demanda, então exibe uma mensagem e oculta os dados de demanda
    const sazonalidadeDiferenteDaUC = props.item.id && props.item.contrato_demanda_sazonal != props.item.sazonal;

    const horosazonalVerde = props.item.id_modalidade_tarifaria == 1;
    const horosazonalAzul = props.item.id_modalidade_tarifaria == 2;
    const corTabelaDemanda = horosazonalVerde ? "#00d85f" : horosazonalAzul ? "#34cbff" : "#ddd";

    // Se houver reativo capacitivo, mantém o kvar_cap negativo; senão, usa o kvar_ind positivo
    const q =
        parseFloat(props.item.consumoLeitura.kvar_cap) < 0
            ? parseFloat(props.item.consumoLeitura.kvar_cap)
            : parseFloat(props.item.consumoLeitura.kvar_ind) > 0
                ? parseFloat(props.item.consumoLeitura.kvar_ind)
                : 0;

    const fatorPotencia = calcularFatorPotencia({
        p: props.item.consumoLeitura.kw,
        q,
    });

    //define se está online ou offline ---------------------------------------------
    const dataHoraLeitura = new Date(props.item.consumoLeitura.data_hora);
    const dataHoraAtualValidacaoRecente = new Date();
    dataHoraAtualValidacaoRecente.setMinutes(dataHoraAtualValidacaoRecente.getMinutes() - 60);
    const onlineRecentemente = dataHoraLeitura >= dataHoraAtualValidacaoRecente;

    let exibirAlertaPkwVermelho = false;
    let exibirAlertaPkwVerde = false;

    //1 fora ponta e 2 ponta
    if (props.filtro.id_tipo_contrato_demanda == 1) {
        exibirAlertaPkwVermelho = parseFloat(props.item.consumoLeitura.kw) > parseFloat(props.item.demanda_fora_ponta_contratada_mes_atual) * 1.05;
        exibirAlertaPkwVerde =
            parseFloat(props.item.consumoLeitura.kw) >= parseFloat(props.item.demanda_fora_ponta_contratada_mes_atual) &&
            parseFloat(props.item.consumoLeitura.kw) <= parseFloat(props.item.demanda_fora_ponta_contratada_mes_atual) * 1.05;
    } else if (props.filtro.id_tipo_contrato_demanda == 2) {
        exibirAlertaPkwVermelho = parseFloat(props.item.consumoLeitura.kw) > parseFloat(props.item.demanda_ponta_contratada_mes_atual) * 1.05;
        exibirAlertaPkwVerde =
            parseFloat(props.item.consumoLeitura.kw) >= parseFloat(props.item.demanda_ponta_contratada_mes_atual) &&
            parseFloat(props.item.consumoLeitura.kw) <= parseFloat(props.item.demanda_ponta_contratada_mes_atual) * 1.05;
    }

    const valorQAlterado = parseFloat(q) && kvarIndSimulado && kvarIndSimulado !== parseFloat(q);

    const grupoFaturamentoTipoMedicao =
        props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 1
            ? "GA - Med. BT"
            : props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 2
              ? "GA - Med. MT"
              : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 1
                ? "GB - Med. BT"
                : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 2
                  ? "GB - Med. MT"
                  : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 1
                    ? "GA/FB - Med. BT"
                    : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 2
                      ? "GA/FB - Med. MT"
                      : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 1
                        ? "GA/FA - Med. BT"
                        : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 2
                          ? "GA/FA - Med. MT"
                          : "INDEFINIDO";

    const titleGrupoFaturamentoTipoMedicao =
        props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 1
            ? "Grupo A com medição de Baixa Tensão"
            : props.item.id_grupo_faturamento == 1 && props.item.id_tipo_medicao == 2
              ? "Grupo A com medição de Média Tensão"
              : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 1
                ? "Grupo B com medição de Baixa Tensão"
                : props.item.id_grupo_faturamento == 2 && props.item.id_tipo_medicao == 2
                  ? "Grupo B com medição de Média Tensão"
                  : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 1
                    ? "Grupo A/Faturado em B com medição de Baixa Tensão"
                    : props.item.id_grupo_faturamento == 3 && props.item.id_tipo_medicao == 2
                      ? "Grupo A/Faturado em B com medição de Média Tensão"
                      : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 1
                        ? "Grupo A/Faturado em A com medição de Baixa Tensão"
                        : props.item.id_grupo_faturamento == 4 && props.item.id_tipo_medicao == 2
                          ? "Grupo A/Faturado em A com medição de Média Tensão"
                          : "INDEFINIDO";

    const primeiroItemHistorico = (props.item.historico || [])[0] || {};
    const ultimoRegistroEmAndamento = primeiroItemHistorico.status === "Em andamento" || primeiroItemHistorico.status === "Iniciada";

    const corVermelha = "#ff3164";
    const corVerde = "#15b85b";

    // return props.modoCard ? (
    return (
        <ContentCard style={{ backgroundColor: props.backgroundColor, color: props.color, borderRadius: 12, marginBottom: 35 }}>
            <ContentCardBody padding="10px">
                <RowFlex style={{ justifyContent: "center", padding: "0 !important" }}>
                    <h6 style={{ textAlign: "center" }}>{props.item.nome_unidade_consumidora}</h6>
                </RowFlex>
                <RowFlex style={{ justifyContent: "center", padding: "0 !important" }}>
                    <div className="d-flex align-items-center" style={{ position: "relative", marginTop: 10 }}>
                        <div
                            style={{
                                position: "absolute",
                                left: 5,
                                top: -2,
                                fontSize: "1rem",
                                color: onlineRecentemente ? corVerde : corVermelha,
                            }}
                        >
                            <i className="fas fa-wifi"></i>
                        </div>
                        {!onlineRecentemente && (
                            <div
                                style={{
                                    position: "absolute",
                                    left: 5,
                                    top: -2,
                                    fontSize: "1rem",
                                    color: corVermelha,
                                }}
                            >
                                <i className="fas fa-slash"></i>
                            </div>
                        )}
                        <span
                            style={{
                                fontSize: "0.7rem",
                                paddingTop: 18,
                                color: onlineRecentemente ? corVerde : corVermelha,
                            }}
                        >
                            {onlineRecentemente ? <b>online</b> : <b>offline</b>}
                        </span>
                        {props.item.consumoLeitura.data_hora ? (
                            <div style={{ paddingLeft: 12, fontSize: "0.8rem" }}>{DateFormat.formatarDataHoraSqlParaTelaShortYear(props.item.consumoLeitura.data_hora)}</div>
                        ) : (
                            "-"
                        )}
                    </div>
                </RowFlex>
                <RowFlex style={{ justifyContent: "center", padding: "0 !important" }}>
                    {sazonalidadeDiferenteDaUC ? (
                        <div
                            style={{
                                backgroundColor: "#fd5959",
                                color: "#ffffff",
                                padding: 5,
                                borderRadius: "0.3rem",
                                textAlign: "center",
                            }}
                        >
                            <div style={{ width: "100%", minWidth: 150 }}>
                                <div>A sazonalidade da UC é diferente do contrato</div>
                                <div>
                                    (UC:{props.item.contrato_demanda_sazonal ? " Sazonal " : " Não Sazonal "} - Contrato:
                                    {props.item.sazonal ? " Sazonal " : " Não Sazonal "})
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex">
                            <TooltipAgendamento item={props.item} />
                            <TooltipPeriodoTeste
                                setPeriodoTesteVisualizado={props.setPeriodoTesteVisualizado}
                                getMonitoramentoConsumo={props.getMonitoramentoConsumo}
                                item={props.item}
                            />
                        </div>
                    )}
                </RowFlex>
                <RowFlex style={{ justifyContent: "flex-end", padding: "0 !important" }}>
                    <Button
                        style={{ width: "100%", height: 80, margin: 8 }}
                        title="Ver o gráfico do dia"
                        text={
                            <div>
                                <div>
                                    <i style={{ fontSize: "2rem" }} className="fas fa-chart-line"></i>
                                </div>
                                <b>P e Q</b>
                            </div>
                        }
                        type={"info"}
                        event={() => {
                            props.getListaGraficoDia({
                                id_consumo_integracao: props.item.consumoLeitura.id_consumo_integracao,
                                dataInicial: props.dataInicialGrafico,
                                dataFinal: props.dataFinalGrafico,
                            });
                            props.setModoTela("graficoDia", props.item);
                        }}
                    />
                    <IndicadorLeiturasFaltando item={props.item} visible={props.usuarioLogado.administrador} />
                </RowFlex>

                <RowFlex style={{ padding: "0 !important", margin: 1 }}>
                    <Grid cols="12 12 12 12" style={{ marginBlock: 0, border: "2px solid #FFF" }}>
                        <div
                            style={{
                                textAlign: "center",
                                lineHeight: "1.1rem",
                                color: exibirAlertaPkwVermelho ? corVermelha : exibirAlertaPkwVerde ? corVerde : null,
                            }}
                        >
                            {exibirAlertaPkwVermelho && (
                                <AlertIcon
                                    animationClass={props.item.consumoLeitura.status_visualizado_kw ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                    title="A demanda medida em kW está igual ou superior à contratada"
                                    event={() => {
                                        if (window.confirm('A demanda medida em kW está igual ou superior à contratada, deseja marcar alerta como "visualizado"?')) {
                                            props.setStatusVisualizado({
                                                id: props.item.consumoLeitura.id,
                                                coluna: "status_visualizado_kw",
                                            });
                                            props.item.consumoLeitura.status_visualizado_kw = true;
                                        }
                                    }}
                                />
                            )}
                            {!isNaN(parseFloat(props.item.consumoLeitura.kw)) ? (
                                <h4 style={{ padding: 15, margin: 0 }}>{adicionarPontosMilhar(props.item.consumoLeitura.kw) + " kW"}</h4>
                            ) : (
                                "-"
                            )}
                        </div>
                    </Grid>
                    <Grid cols="12 12 12 12" style={{ marginBlock: 0, border: "2px solid #FFF", borderTop: "none", paddingBlock: 5 }}>
                        <RowFlex style={{ padding: "0 !important" }}>
                            <Grid cols="6 6 6 6">
                                <div
                                    title={
                                        props.item.consumoLeitura.potencia_reativa_a || props.item.consumoLeitura.potencia_reativa_b || props.item.consumoLeitura.potencia_reativa_c
                                            ? `(Potência Reativa A: ${adicionarPontosMilhar(props.item.consumoLeitura.potencia_reativa_a)}, Potência Reativa B: ${adicionarPontosMilhar(
                                                  props.item.consumoLeitura.potencia_reativa_b
                                              )}, Potência Reativa C: ${adicionarPontosMilhar(props.item.consumoLeitura.potencia_reativa_c)}) multiplicadas pela constante do medidor`
                                            : "Q(kVAr) multiplicado pela constante do medidor"
                                    }
                                    style={{
                                        textAlign: "center",
                                        position: "relative",
                                        textDecoration: valorQAlterado ? "line-through" : "none",
                                    }}
                                >
                                    {/* {valorQAlterado ? <i className="fas fa-arrow-down display-6" style={{ position: "absolute", left: "40%", top: 34, color: "#25f655" }} /> : null} */}
                                    {!isNaN(parseFloat(q)) ? (
                                        <h6>
                                            Q = <span style={{ marginInline: 4 }}>{adicionarPontosMilhar(q)}</span> kVAr
                                        </h6>
                                    ) : (
                                        "-"
                                    )}
                                </div>
                                {valorQAlterado ? <div>{adicionarPontosMilhar(kvarIndSimulado)}</div> : null}
                            </Grid>
                            <Grid cols="6 6 6 6">
                                {!isNaN(fatorPotencia) ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            lineHeight: "1.1rem",
                                            color: fatorPotencia < 0.92 ? corVermelha : corVerde,
                                        }}
                                    >
                                        {fatorPotencia < 0.92 && (
                                            <AlertIcon
                                                animationClass={props.item.consumoLeitura.status_visualizado_fp ? "alerta-triangulo-visualizado" : "alerta-triangulo"}
                                                title="FP está abaixo de 0,92"
                                                event={() => {
                                                    if (window.confirm('FP está abaixo de 0,92, deseja marcar alerta como "visualizado"?')) {
                                                        props.setStatusVisualizado({
                                                            id: props.item.consumoLeitura.id,
                                                            coluna: "status_visualizado_fp",
                                                        });
                                                        props.item.consumoLeitura.status_visualizado_fp = true;
                                                    }
                                                }}
                                            />
                                        )}
                                        <div>
                                            <h6 title="FP = P / S">
                                                FP =<span style={{ marginInline: 4 }}>{adicionarPontosMilhar(fatorPotencia)}</span>
                                            </h6>
                                        </div>
                                    </div>
                                ) : (
                                    "-"
                                )}
                            </Grid>
                            <Grid cols="12 12 12 12">
                                <div style={{ textAlign: "center", paddingTop: 5 }}>
                                    {!isNaN(parseFloat(props.item.consumoLeitura.kw)) && !isNaN(parseFloat(q)) ? (
                                        <h6>
                                            S =
                                            <span style={{ marginInline: 4 }}>
                                                {adicionarPontosMilhar(Math.sqrt(Math.pow(parseFloat(props.item.consumoLeitura.kw), 2) + Math.pow(parseFloat(q), 2)))}
                                            </span>
                                            kVA
                                        </h6>
                                    ) : (
                                        "-"
                                    )}
                                </div>
                            </Grid>
                        </RowFlex>
                    </Grid>
                </RowFlex>

                <RowFlex style={{ justifyContent: "center", padding: "0 !important", margin: "20px 1px" }}>
                    <Grid cols="12 12 12 12" style={{ marginBlock: 0, border: "2px solid #FFF", paddingBlock: 20 }}>
                        <RowFlex style={{ justifyContent: "center", padding: "0 !important" }}>
                            <Grid cols="5 5 5 5" style={{ textAlign: "center", paddingInline: 0 }}>
                                <h6 style={{ marginTop: 3, fontWeight: "bold", fontSize: "0.73rem" }}>Maior Demanda do Mês</h6>
                                <h6 style={{ backgroundColor: props.item.consumoLeitura.cor_maior_demanda_mes, borderRadius: 5, padding: 4 }}>
                                    {adicionarPontosMilhar(props.item.consumoLeitura.maior_demanda_mes) + " kW" || "-"}
                                </h6>
                                <div style={{ fontSize: "0.73rem", textAlign: "center" }}>
                                    <div>Atingida em</div>
                                    <div>
                                        {props.item.consumoLeitura.datahora_maior_demanda_mes ? (
                                            <span>{DateFormat.formatarDataHoraSqlParaTela(props.item.consumoLeitura.datahora_maior_demanda_mes)}</span>
                                        ) : (
                                            "-"
                                        )}
                                    </div>
                                </div>
                            </Grid>
                            <Grid cols="7 7 7 7">
                                <div className="d-flex justify-content-center">
                                    <b style={{ width: "100%", textAlign: "center", fontSize: "0.73rem" }}>Demanda Contratada Mês Atual</b>
                                </div>
                                <TabelaDemandaContratada corTabelaDemanda={corTabelaDemanda} item={props.item} tableWidth="100%" />
                            </Grid>
                        </RowFlex>
                    </Grid>
                </RowFlex>
                <RowFlex style={{ justifyContent: "flex-end", padding: "0 !important" }}>
                    <Grid cols="12 12 12 12">
                        <Button
                            style={{ margin: 0 }}
                            text="Análise de Demanda Contratada"
                            type={"purple"}
                            icon={"fas fa-chart-bar"}
                            visible={true}
                            solid={true}
                            disabled={!props.item.id}
                            event={() => {
                                const ucCompleta = props.listaUnidadeConsumidora.find((uc) => uc.id === props.item.id_unidade_consumidora) || {};
                                props.setExibirModalAnaliseDemandaContratada(true);
                                props.setItemSelecionado({ ...props.item, id_cliente: ucCompleta.id_cliente });
                            }}
                        />
                    </Grid>
                    <Grid cols="6 6 6 6">
                        <Button
                            title={ultimoRegistroEmAndamento ? "Existe um ajuste de demanda em andamento" : "Histórico"}
                            style={{ margin: 0 }}
                            text={<span>Histórico de Alterações {ultimoRegistroEmAndamento ? <img height={20} width={20} src={ampulhetaCirculo} alt="" /> : null}</span>}
                            type={"brown"}
                            icon={"fas fa-book"}
                            visible={true}
                            solid={true}
                            disabled={!(props.item.historico || []).length}
                            event={() => {
                                props.setExibirModalHistorico(true);
                                props.setItemSelecionado(props.item);
                            }}
                        />
                    </Grid>
                    <Grid cols="6 6 6 6">
                        <Button
                            title={"Unifilar de Rede Interna"}
                            style={{ margin: 0 }}
                            text={"Rede Elétrica Interna"}
                            type={"light"}
                            icon={"fas fa-network-wired"}
                            visible={true}
                            solid={true}
                            disabled={!props.item.possui_unifilar_rede_interna}
                            event={() => {
                                props.buscarPdfUnifilarRedeInterna({
                                    id_unidade_consumidora: props.item.id_unidade_consumidora,
                                    nome: `Mapa_unifilar_rede_interna`,
                                });
                                props.setArquivoPDF();
                            }}
                        />
                    </Grid>
                </RowFlex>
                <RowFlex style={{ justifyContent: "flex-end", padding: "0 !important" }}>
                    <Grid cols="6 6 6 6">
                        <div style={{ width: 160 }}>
                            <IndicadorDemandasAtingidasUltrapassagem
                                titleGrupoFaturamentoTipoMedicao={titleGrupoFaturamentoTipoMedicao}
                                grupoFaturamentoTipoMedicao={grupoFaturamentoTipoMedicao}
                                ultimaLinha={props.ultimaLinha}
                                item={props.item}
                                color={props.color}
                                sazonalidadeDiferenteDaUC={sazonalidadeDiferenteDaUC}
                            />
                        </div>
                    </Grid>
                    <Grid cols="6 6 6 6" style={{ color: "#fff", textAlign: "center" }}>
                        <IndicadoresFator
                            modoTabela={true}
                            sazonalidadeDiferenteDaUC={sazonalidadeDiferenteDaUC}
                            item={props.item}
                            paddingBlock={11}
                            heightTabela={160}
                            borderColorTabela={"#FFF"}
                        />
                    </Grid>
                </RowFlex>
            </ContentCardBody>
        </ContentCard>
    );
}

const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        filtro: state.monitoramentoConsumo.filtro,
        listaUnidadeConsumidora: state.monitoramentoConsumo.listaUnidadeConsumidora,
        listaMonitoramentoConsumo: state.monitoramentoConsumo.listaMonitoramentoConsumo,
        dataInicialGrafico: state.monitoramentoConsumo.dataInicialGrafico,
        dataFinalGrafico: state.monitoramentoConsumo.dataFinalGrafico,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            buscarPdfUnifilarRedeInterna,
            setArquivoPDF,
            setModoTela,
            getListaGraficoDia,
            getMonitoramentoConsumo,
            setStatusVisualizado,
            setPeriodoTesteVisualizado,
        },
        dispatch
    );
const MonitoramentoConsumoCardMobile = connect(mapStateToProps, mapDispatchToProps)(MonitoramentoConsumoCardMobileComponent);
export { MonitoramentoConsumoCardMobile };
